<template>
    <div class="input-group input-group-merge">
        <!-- Input -->
        <b-form-input
            :type="visible ? 'text' : 'password'"
            :tabindex="tabindex"
            :state="state"
            v-bind:value="value"
            v-on:input="$emit('input', $event)"
            :aria-describedby="labelId"
            class="form-control form-control-appended"
            :placeholder="placeholder"
        />
        <!-- Icon -->
        <div class="input-group-append" @click="visible=!visible">
            <span class="input-group-text">
                <i class="fe fe-eye-off" v-if="!visible"></i>
                <i class="fe fe-eye" v-else></i>
            </span>
        </div>
        <b-form-invalid-feedback :id="labelId" v-html="errorMessage">
        </b-form-invalid-feedback>
    </div>
</template>

<script>
export default {
    props: {
        value: null,
        placeholder: { type: String, default: '' },
        errorMessage: { type: String, default: '' },
        tabindex: { type: [Number, String], default: 0 },
        state: null
    },
    data() {
        return {
            visible: false,
        }
    },
    computed: {
        labelId() {
            return 'error-message.' + this._uid.toString()
        }
    }
}
</script>

<style>

</style>
